import { PriorityModel } from './priority.model';

export class FormElementChoicePriorityModel {
  id: string;
  priority: PriorityModel;
  constructor() {
    this.priority = new PriorityModel();
  }
}
